class CustomDropdown extends HTMLElement {
  constructor() {
    super();

    this.trigger = null;
    this.options = null;
    this.selectedText = null;
    this.isOpen = false;
  }

  connectedCallback() {
    if (this.dataset.type === 'upsell') {
      return;
    }
    
    this.trigger = this.querySelector('.variant-dropdown__trigger');
    this.options = this.querySelectorAll('.variant-dropdown__option');
    this.selectedText = this.querySelector('.variant-dropdown__selected');
    
    if (!this.selectedText.dataset.placeholder) {
      this.selectedText.dataset.placeholder = this.selectedText.textContent.trim();
    }

    this.setupDropdown();
  }

  setupDropdown() {
    this.trigger.addEventListener('click', (e) => {
      e.preventDefault();
      if (this.dataset.disabled === 'true') {
        return;
      }
      this.toggle();
    });

    this.options.forEach((option) => {
      option.addEventListener('click', (e) => {
        if (this.dataset.type === 'upsell') {
          return;
        }
        
        if (this.dataset.disabled === 'true') {
          return;
        }
        
        e.preventDefault();
        e.stopPropagation();
        
        const value = option.dataset.value;
        const isAlreadySelected = option.classList.contains('selected');
        
        if (isAlreadySelected) {
          this.options.forEach((opt) => opt.classList.remove('selected'));
          this.selectedText.textContent = this.selectedText.dataset.placeholder || 'Select';
          this.selectedText.style.color = '#bcb6b4';
          
          const optionIndex = this.dataset.optionIndex;
          
          if (optionIndex !== undefined) {
            this.dispatchEvent(new CustomEvent('dropdown-option-selected', {
              detail: {
                value: null,
                optionIndex: parseInt(optionIndex),
                variantId: null,
                optionElement: null
              },
              bubbles: true
            }));
          }
          
          setTimeout(() => {
            this.close();
          }, 10);
          return;
        }
        
        this.selectOption(value, option);
      });
    });

    document.addEventListener('click', (e) => {
      if (!this.contains(e.target) && this.isOpen) {
        this.close();
      }
    });
    
    if (window.innerWidth <= 768) {
      const options = this.querySelector('.variant-dropdown__options');
      if (options) {
        const overlay = document.createElement('div');
        overlay.className = 'variant-dropdown__overlay-mobile';
        overlay.addEventListener('click', () => {
          this.close();
        });
        document.body.appendChild(overlay);
        this.overlay = overlay;
        
        const closeBtn = document.createElement('button');
        closeBtn.className = 'variant-dropdown__close-mobile';
        closeBtn.setAttribute('aria-label', 'Close');
        closeBtn.innerHTML = `
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        `;
        closeBtn.addEventListener('click', (e) => {
          e.stopPropagation();
          this.close();
        });
        const header = options.querySelector('.variant-dropdown__mobile-header');
        if (header) {
          
          let titleWrapper = header.querySelector('div:not(.variant-dropdown__close-mobile)');
          
          if (!titleWrapper) {
            const headerText = header.textContent.trim();
            if (headerText) {
              header.textContent = '';
              
              titleWrapper = document.createElement('div');
              titleWrapper.textContent = headerText;
              header.appendChild(titleWrapper);
            }
          }
          
          if (!header.querySelector('.variant-dropdown__close-mobile')) {
            header.appendChild(closeBtn);
          }
        } else {
          options.insertBefore(closeBtn, options.firstChild);
        }
      }
    }
  }

  toggle() {
    if (this.isOpen) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    if (this.dataset.disabled === 'true') {
      return;
    }
    
    this.isOpen = true;
    this.dataset.open = 'true';
    
    if (window.innerWidth <= 768) {
      if (this.overlay) {
        this.overlay.classList.add('show');
      }
      
      const scrollY = window.scrollY;
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollY}px`;
      document.body.style.width = '100%';
      this.scrollY = scrollY;
      
      const container = this.querySelector('.variant-dropdown__options');
      if (container) {
        container.offsetHeight;
        container.style.transform = '';
        container.style.opacity = '';
      }
    }
  }

  close() {
    const container = this.querySelector('.variant-dropdown__options');
    
    if (container && window.innerWidth <= 768) {
      // Hide overlay
      if (this.overlay) {
        this.overlay.classList.remove('show');
      }
      
      container.style.transform = 'translateY(100%)';
      container.style.opacity = '0';
      container.style.visibility = 'hidden';
      
      setTimeout(() => {
        this.isOpen = false;
        this.dataset.open = 'false';
        document.body.style.overflow = '';
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.width = '';
        
        if (this.scrollY !== undefined) {
          window.scrollTo(0, this.scrollY);
          this.scrollY = undefined;
        }
        
        container.style.transform = '';
        container.style.opacity = '';
        container.style.visibility = '';
      }, 300);
    } else {
      this.isOpen = false;
      this.dataset.open = 'false';
    }
  }

  selectOption(value, optionElement) {
    const isAlreadySelected = optionElement.classList.contains('selected');
    
    if (isAlreadySelected) {
      this.options.forEach((opt) => opt.classList.remove('selected'));
      this.selectedText.textContent = this.selectedText.dataset.placeholder || 'Select';
      this.selectedText.style.color = '#bcb6b4';
      
      const isUpsell = this.dataset.type === 'upsell';
      const optionIndex = this.dataset.optionIndex;
      
      if (!isUpsell && optionIndex !== undefined) {
        this.dispatchEvent(new CustomEvent('dropdown-option-selected', {
          detail: {
            value: null,
            optionIndex: parseInt(optionIndex),
            variantId: null,
            optionElement: null
          },
          bubbles: true
        }));
      }
      
      setTimeout(() => {
        this.close();
      }, 10);
      return;
    }
    
    this.selectedText.textContent = value;
    this.selectedText.style.color = '#534949';
    
    this.options.forEach((opt) => opt.classList.remove('selected'));
    optionElement.classList.add('selected');

    const isUpsell = this.dataset.type === 'upsell';
    const optionIndex = this.dataset.optionIndex;
    const variantId = optionElement.dataset.variantId;
    
    if (!isUpsell && optionIndex !== undefined) {
      const input = document.querySelector(`input[data-variant-head="${value}"][data-head-position="${optionIndex}"]`);
      
      if (input) {
        input.click();
      }
      
      this.dispatchEvent(new CustomEvent('dropdown-option-selected', {
        detail: {
          value: value,
          optionIndex: parseInt(optionIndex),
          variantId: variantId,
          optionElement: optionElement
        },
        bubbles: true
      }));
    }
    
    this.close();
  }
}

if (customElements.get('custom-dropdown') === undefined) {
  customElements.define('custom-dropdown', CustomDropdown);
}

